import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { FunctionComponent } from "react";
import StackComponent from "../../../../components/stack";

interface EstadosstackComponentProps {
  objectWithValues: any[]
}

const EstadosStackComponent: FunctionComponent<EstadosstackComponentProps> = ({ objectWithValues }) => {

  return (<>
    <StackComponent
      icon={<FmdGoodIcon />}
      title="Estados"
      total={`${objectWithValues?.length}`}
      valueActual={`Novos 0`}
    />
  </>);
}

export default EstadosStackComponent;
